import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-block" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = {
  key: 0,
  class: "modal-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.subTitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subTitle), 1))
      : _createCommentVNode("", true)
  ]))
}